import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArmMeasureVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={293}
    height={426}
    fill="none"
    {...props}
  >
    <path
      stroke="#EEEFFF"
      strokeWidth={3}
      d="M214.5 425c-1.833-13.667-3.6-45.4-6-63-3-22 4.5-61 6-70.5s9-68.808 14-81.5 10-42.5 11-46.5 5-11 7-18.5 1-6.5 1-14.5c0-6.4 11.333-57.333 17-82 .667 0 2.6-.6 5-3 3-3 2.5-5 4.5-9.5s17.5-6.5 17-10-18.5 3-19 1.5 10-10.5 8.5-13-12 9-14 8 10-14 7.5-16.5-12.5 12.5-14 12.5 3-16.5 0-17-10 21-11 21-5.5-8-9-11c-2.8-2.4-7.167-1-9 0l7 7c1.6 1.6 7 13 9.5 18.5-4 15.5-25 71-30.5 103-4.732 27.534-28.5 94.5-36.863 94.5s-14.458-6.551-12.788-11.808c4.624-7.056 10.015-12.389 12.788-21.538 2.161-2.564 6.484-9.154 6.484-15s-3.213-6.282-4.819-5.77C179.607 142.748 159.285 140 146.537 140c-11.319 0-31.286 1.035-33.357 40.384-1.6-.769-4.8-.692-4.8 5.77s4.322 12.692 6.483 15c2.773 9.149 8.164 14.482 12.788 21.538 2.151 9.693-7.651 11.808-14.776 11.808-8.363 0-32.13-66.966-36.863-94.5-5.5-32-26.5-87.5-30.5-103 2.5-5.5 7.9-16.9 9.5-18.5l7-7c-1.834-1-6.2-2.4-9 0-3.5 3-8 11-9 11s-8-21.5-11-21 1.5 17 0 17-11.5-15-14-12.5 9.5 15.5 7.5 16.5-12.5-10.5-14-8 9 11.5 8.5 13-18.5-5-19-1.5 15 5.5 17 10 1.5 6.5 4.5 9.5c2.4 2.4 4.333 3 5 3 5.666 24.667 17 75.6 17 82 0 8-1 7 1 14.5s6 14.5 7 18.5 6 33.808 11 46.5 12.5 72 14 81.5 9 48.5 6 70.5c-2.4 17.6-4.167 49.333-6 63"
    />
  </svg>
);
export default SvgArmMeasureVector;
